module.exports = __webpack_public_path__ + "assets/img/13.2823b045.png";